import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type stepType = {
  step: number;
};
const initialState: stepType = {
  step: 0,
};

const stepPersonalManagement = createSlice({
  name: "step",
  initialState,
  reducers: {
    setStep: (state, action: PayloadAction<number>) => {
      state.step = action.payload;
    },
  },
});

export const { setStep } = stepPersonalManagement.actions;
export default stepPersonalManagement.reducer;
